import * as zod from 'zod';

export const EnableGripperVariables = zod.object({
  succeeded: zod.boolean(),
});

export type EnableGripperVariables = zod.infer<typeof EnableGripperVariables>;
